import React, { Component } from 'react'
import List from '../../../component/campus/college/collegeList'
import { changeCollegeStatus, changeUniversityStatus, collegeList } from '../../../actions/campus';
export default class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            college_list: null,
            count: null,
            page: 1,
            showLoader: false,
        }
    }

    componentDidMount() {
        this.loadList(this.state.page)
    }

    onPageChange = (page) => {
        this.setState({ page: page }, () => {
            this.loadList(page)
        })
    }


    onChangesStatus = (COLLEGE_ID, STATUS) => {
        changeCollegeStatus({ COLLEGE_ID: COLLEGE_ID, STATUS: STATUS }).then(res => {
            if (res.status) {
                this.setState({
                    college_list: this.state.college_list.map(item => {
                        if (item.COLLEGE_ID == COLLEGE_ID) {
                            item.STATUS = STATUS
                        }
                        return item
                    })
                })

            }
            else {
                console.error(res.error)
            }
        })
    }
    render() {
        const { college_list, count, page, showLoader } = this.state;
        return (
            <React.Fragment>
                {count && college_list &&
                    <List
                        updateStatus={(id, status) => { this.onChangesStatus(id, status) }}
                        showLoader={showLoader}
                        college_list={college_list}
                        count={count}
                        page={page}
                        onPageChange={(page) => { this.onPageChange(page) }}
                    />
                }
            </React.Fragment>
        )
    }

    loadList(page) {

        collegeList(page).then(res => {
            if (res.status) {
                this.setState({ college_list: res.result.list, count: res.result.count })
            }
        })
    }
}
